import React, { useMemo } from 'react';
import { Box, IconButton, Grid } from '@mui/material';

// Pre-defined emoji categories for better performance
const EMOJI_CATEGORIES = {
  faces: [
    '😀',
    '😃',
    '😄',
    '😁',
    '😆',
    '😅',
    '😂',
    '🤣',
    '😊',
    '😇',
    '🙂',
    '🙃',
    '😉',
    '😌',
    '😍',
    '🥰',
    '😘',
    '😗',
    '😙',
    '😚',
    '😋',
    '😛',
    '😝',
    '😜',
    '🤪',
    '🤨',
    '🧐',
    '🤓',
    '😎',
    '🤩',
    '🥳',
    '😏',
    '😒',
    '😞',
    '😔',
    '😟',
    '😕',
    '🙁',
    '☹️',
    '😣',
    '😖',
    '😫',
    '😩',
    '🥺',
    '😢',
    '😭',
    '😤',
    '😠',
    '😡',
    '🤬',
    '🤯',
    '😳',
    '🥵',
    '🥶',
    '😱',
    '😨',
    '😰',
    '😥',
    '😓',
    '🤗',
    '🤔',
    '🤭',
    '🤫',
    '🤥',
    '😶',
    '😐',
    '😑',
    '😬',
    '🙄',
    '😯',
    '😦',
    '😧',
    '😮',
    '😲',
    '🥱',
    '😴',
    '🤤',
    '😪',
    '😵',
    '🤐',
    '🥴',
    '🤢',
    '🤮',
    '🤧',
    '😷',
    '🤒',
    '🤕',
  ],
  objects: [
    '⌚',
    '📱',
    '💻',
    '⌨️',
    '🖥',
    '🖨',
    '🖱',
    '🖲',
    '🕹',
    '🗜',
    '💽',
    '💾',
    '💿',
    '📀',
    '📼',
    '📷',
    '📸',
    '📹',
    '🎥',
    '📽',
    '🎞',
    '📞',
    '☎️',
    '📟',
    '📠',
    '📺',
    '📻',
    '🎙',
    '🎚',
    '🎛',
    '🧭',
    '⏱',
    '⏲',
    '⏰',
    '🕰',
    '⌛',
    '⏳',
    '📡',
    '🔋',
    '🔌',
    '💡',
    '🔦',
    '🕯',
    '🪔',
    '🧯',
    '🛢',
    '💸',
    '💵',
    '💴',
    '💶',
    '💷',
    '🪙',
    '💰',
    '💳',
    '💎',
    '⚖️',
    '🪜',
    '🧰',
    '🪛',
    '🔧',
    '🔨',
    '⚒',
    '🛠',
    '⛏',
    '🪚',
    '🔩',
    '⚙️',
    '🪤',
    '🧱',
    '⛓',
    '🪝',
    '🧲',
    '🔫',
  ],
  nature: [
    '🌱',
    '🌲',
    '🌳',
    '🌴',
    '🌵',
    '🌾',
    '🌿',
    '☘️',
    '🍀',
    '🍁',
    '🍂',
    '🍃',
    '🌺',
    '🌸',
    '💮',
    '🏵️',
    '🌹',
    '🥀',
    '🌻',
    '🌼',
    '🌷',
    '🌻',
    '🌞',
    '🌝',
    '🌛',
    '🌜',
    '🌚',
    '🌕',
    '🌖',
    '🌗',
    '🌘',
    '🌑',
    '🌒',
    '🌓',
    '🌔',
    '🌙',
    '🌎',
    '🌍',
    '🌏',
    '💫',
    '⭐',
    '🌟',
    '✨',
    '⚡',
    '☄️',
    '💥',
    '🔥',
    '🌪',
    '🌈',
    '☀️',
    '🌤',
    '⛅',
    '🌥',
    '☁️',
    '🌦',
    '🌧',
    '⛈',
    '🌩',
    '🌨',
    '❄️',
    '☃️',
    '⛄',
    '🌬',
    '💨',
    '💧',
    '💦',
    '☔',
    '☂️',
    '🌊',
    '🌫',
  ],
  animals: [
    '🐶',
    '🐱',
    '🐭',
    '🐹',
    '🐰',
    '🦊',
    '🐻',
    '🐼',
    '🐨',
    '🐯',
    '🦁',
    '🐮',
    '🐷',
    '🐽',
    '🐸',
    '🐵',
    '🙈',
    '🙉',
    '🙊',
    '🐒',
    '🐔',
    '🐧',
    '🐦',
    '🐤',
    '🐣',
    '🐥',
    '🦆',
    '🦅',
    '🦉',
    '🦇',
    '🐺',
    '🐗',
    '🐴',
    '🦄',
    '🐝',
    '🐛',
    '🦋',
    '🐌',
    '🐞',
    '🐜',
    '🦗',
    '🕷',
    '🕸',
    '🦂',
    '🦟',
    '🪰',
    '🪱',
    '🦠',
    '🐢',
    '🐍',
    '🦎',
    '🦖',
    '🦕',
    '🐙',
    '🦑',
    '🦐',
    '🦞',
    '🦀',
    '🐡',
    '🐠',
    '🐟',
    '🐬',
    '🐳',
    '🐋',
    '🦈',
    '🐊',
    '🐅',
    '🐆',
    '🦓',
    '🦍',
    '🦧',
    '🐘',
    '🦛',
    '🦏',
    '🐪',
    '🐫',
    '🦒',
    '🦘',
    '🐃',
    '🐂',
    '🐄',
    '🐎',
    '🐖',
    '🐏',
    '🐑',
    '🦙',
    '🐐',
    '🦌',
    '🐕',
    '🐩',
    '🦮',
    '🐕‍🦺',
    '🐈',
    '🐈‍⬛',
    '🐓',
    '🦃',
    '🦚',
    '🦜',
    '🦢',
    '🦩',
    '🕊',
    '🐇',
    '🦝',
    '🦨',
    '🦡',
    '🦫',
    '🦦',
    '🦥',
    '🐁',
    '🐀',
    '🦔',
  ],
};

const EmojiPicker = ({ onEmojiSelect }) => {
  // Memoize the emoji grid to prevent unnecessary re-renders
  const emojiGrid = useMemo(() => {
    return Object.values(EMOJI_CATEGORIES).flat();
  }, []);

  return (
    <Box
      sx={{
        p: 1,
        maxHeight: '300px',
        overflowY: 'auto',
        width: '300px',
        bgcolor: 'background.paper',
        boxShadow: 3,
        borderRadius: 1,
      }}
    >
      <Grid container spacing={1}>
        {emojiGrid.map((emoji, index) => (
          <Grid item key={index}>
            <IconButton
              size='small'
              onClick={() => onEmojiSelect(emoji)}
              sx={{
                fontSize: '1.5rem',
                p: 0.5,
                '&:hover': {
                  bgcolor: 'action.hover',
                },
              }}
            >
              {emoji}
            </IconButton>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default EmojiPicker;
